import React from "react";
import { Link } from "react-router-dom";
import { Activity } from "lucide-react";
import { RiskBadge } from "@/components/risk/RiskBadge";

export const ActivityFeed = ({ activity }) => (
  <div className="rounded-xl border bg-card" data-testid="dashboard-activity-feed">
    <div className="flex items-center gap-2 border-b px-5 py-4">
      <Activity className="h-4 w-4 text-primary" />
      <h3 className="font-display text-base font-semibold">Recent activity</h3>
    </div>
    {(!activity || activity.length === 0) ? (
      <p className="p-6 text-sm text-muted-foreground">No recent activity yet.</p>
    ) : (
      <div className="max-h-80 divide-y overflow-y-auto">
        {activity.map((a) => (
          <Link key={a.id} to={`/app/result/${a.id}`} className="flex items-center justify-between px-5 py-3 transition-colors hover:bg-accent/40">
            <div className="min-w-0">
              <p className="truncate text-sm font-medium">Assessment · {a.guest_initials || "—"} <span className="text-muted-foreground">({a.platform})</span></p>
              <p className="text-xs text-muted-foreground">{a.property_name || "No property"} · {new Date(a.created_at).toLocaleString()}</p>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-display text-sm font-semibold tabular-nums">{a.overall_score}</span>
              <RiskBadge band={a.risk_band} size="sm" />
            </div>
          </Link>
        ))}
      </div>
    )}
  </div>
);
